import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber";

const phoneUtil = PhoneNumberUtil.getInstance();

export const formatInputPhoneNumber = (phoneNumber: string | undefined, defaultRegion = "ZZ"): string => {
  if (!phoneNumber) {
    return "";
  }
  try {
    const parsed = phoneUtil.parseAndKeepRawInput(phoneNumber, defaultRegion);
    return phoneUtil.format(parsed, PhoneNumberFormat.E164);
  } catch {
    return phoneNumber;
  }
};

export const formatPhoneNumber = (phoneNumber: string | undefined): string => {
  if (!phoneNumber) {
    return "";
  }
  try {
    const parsed = phoneUtil.parse(phoneNumber, "ZZ");
    return phoneUtil.format(parsed, PhoneNumberFormat.INTERNATIONAL);
  } catch {
    return phoneNumber;
  }
};

export const isValidPhoneNumber = (phoneNumber: string | undefined): boolean => {
  if (!phoneNumber) {
    return false;
  }
  try {
    const parsed = phoneUtil.parse(phoneNumber, "ZZ");
    return phoneUtil.isValidNumber(parsed);
  } catch {
    return false;
  }
};
